














































































import Vue from 'vue'
import { range } from '@/common/utils'

export default Vue.extend({
  props: {
    totalNumberOfItems: {
      type: Number,
      required: true
    },
    numberOfItemsPerPage: {
      type: Number,
      required: true
    },
    /**
     * Number of maximum items to display in pages.
     * For example
     * 10 pages: [Prev] 1 2 3 4 5 6 7 8 9 10 [Next]
     * 05 pages: [Prev] 4 5 6 7 8 [Next]
     * (On mobile maximum number is 5 no matter the passed in prop)
     */
    maxNumberOfDisplayPages: {
      type: Number,
      required: true
    },
    selectedPage: {
      type: Number,
      required: true
    },
    /**
     * Path to create anchor tags href for crawling bot
     */
    pathName: {
      type: String,
      default: ''
    }
  },
  computed: {
    isMobile(): boolean {
      return window.innerWidth <= 768
    },
    numberOfPages(): number {
      return Math.ceil(this.totalNumberOfItems / this.numberOfItemsPerPage)
    },
    isFirstPage(): boolean {
      return this.selectedPage === 1
    },
    isLastPage(): boolean {
      return this.selectedPage == this.numberOfPages
    },
    displayPageNumbersList(): number[] {
      let threshold
      let startPage
      let endPage
      const numberOfDisplayPages = this.isMobile ? 3 : this.maxNumberOfDisplayPages

      if (numberOfDisplayPages % 2) {
        threshold = Math.floor(numberOfDisplayPages / 2)
        startPage = this.selectedPage - threshold
        endPage = this.selectedPage + threshold
      }
      else {
        threshold = numberOfDisplayPages / 2
        startPage = this.selectedPage - threshold + 1
        endPage = this.selectedPage + threshold
      }

      const toTrim = this.numberOfPages > numberOfDisplayPages
      const isInBetweenNumber = threshold < this.selectedPage && this.selectedPage <= this.numberOfPages - threshold
      const isBeginningNumber = 0 < this.selectedPage && this.selectedPage <= threshold
      const isEndingNumber = this.numberOfPages - threshold < this.selectedPage && this.selectedPage <= this.numberOfPages

      if (!toTrim) return range(1, this.numberOfPages)
      else if (isBeginningNumber) return range(1, numberOfDisplayPages)
      else if (isInBetweenNumber) return range(startPage, endPage)
      else if (isEndingNumber) return range(this.numberOfPages - numberOfDisplayPages + 1, this.numberOfPages)
      else throw new Error('Selected page out of range')
    },
    totalPagesCount(): number[] {
      return new Array(this.numberOfPages).fill(0).map((v, i) => i + 1)
    },
    firstPageCount(): number {
      return this.totalPagesCount[0]
    },
    lastPageCount(): number {
      return this.totalPagesCount[this.totalPagesCount.length - 1]
    },
    showPreviousPlaceholder(): boolean {
      return (this.displayPageNumbersList[0] - this.firstPageCount) > 1
    },
    showNextPlaceholder(): boolean {
      return (this.lastPageCount - this.displayPageNumbersList[this.displayPageNumbersList.length - 1]) > 1
    },
    showFirstPage(): boolean {
      return this.totalPagesCount[1] === this.displayPageNumbersList[0] || this.showPreviousPlaceholder
    },
    showLastPage(): boolean {
      return this.totalPagesCount[this.totalPagesCount.length - 2] === this.displayPageNumbersList[this.displayPageNumbersList.length - 1] || this.showNextPlaceholder
    }
  },
  methods: {
    getUrlForCrawlingBot(pageIndex: number) {
      return `${this.pathName || window.location.pathname}?page=${pageIndex}`
    },
    selectPage(pageNumber: number) {
      if (pageNumber < 1) return
      if ( pageNumber > this.numberOfPages) return
      this.$emit('selectPage', pageNumber)
    }
  }
})
